import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

/** Name to show for another user; `null` from the API means the account was deleted (T-804). */
export function usePersonName(): (displayName: string | null) => string {
	const { t } = useTranslation();
	return (displayName) => displayName ?? t('profile.deleted_account');
}

/** A link to a profile, or a plain row for a deleted account (it has no profile to open). */
export function PersonLink({
	to,
	deleted,
	className,
	children,
}: {
	to: string;
	deleted: boolean;
	className: string;
	children: ReactNode;
}) {
	if (deleted) return <div className={className}>{children}</div>;
	return (
		<Link to={to} className={className}>
			{children}
		</Link>
	);
}
